module.exports = __webpack_public_path__ + "img/healthy-engage-watermark.a3bb361f.png";